export class ChartItem {
  constructor(public name: string, public value: number, public label: string, public colour: string) {
  }
}
